import React from 'react'
import ReactDOM from 'react-dom'
import _ from 'lodash';

class Mininav extends React.Component{

    constructor(props){
      super(props);
    }

    render(){
      var {currentUser, onLogout} = this.props;

      return ReactDOM.createPortal(<React.Fragment>
        {!_.isEmpty(currentUser) && <div style={{"position":"absolute","top":"80px","zIndex":"2","backgroundColor":"white","padding":"10px 15px","borderRadius":"0 0 6px 6px","right":"230px", "color": "#0a1f44"}}>
          Logged in as: <b>{currentUser.email}</b>, <a href="#" onClick={onLogout}>Logout</a>

          <div style={{fontSize: '14px', marginTop: '10px'}}>
            You have access to: <br />
            <i className="fas fa-check" /> unlimited blog ideas <br />
          </div>

        </div>}
      </React.Fragment>, document.getElementById('mininav'));
    }

}

export default Mininav